import { useApiUrl } from '@gemini/lux-ds-pms';
import { OBRoutes } from '@utils/apiRoutes';
import { CountryListDTO } from '@utils/interfaces';
import { useOBQuery } from '@hooks/useOBQuery';
import { useOnlineBookingStore } from '@store/onlineBookingStore';

const useGetCountryList = () => {
  const brandName = useOnlineBookingStore(state => state.brandName);

  const url =
    useApiUrl(OBRoutes.CountryList, 'ONLINEBOOKING_CLIENT_BFF_API_BASE_URL') ||
    undefined;

  // if brandName -> this service is not needed
  const enabled = !!url && !brandName;

  const query = useOBQuery<CountryListDTO>(url, { enabled });

  return {
    ...query,
    isLoading: enabled ? query.isLoading : false,
  };
};

export default useGetCountryList;
